export type NavItem = { label: string; href: string; locked?: boolean; plan?: string };
export function Nav({ items, current }: { items: NavItem[]; current: string }) {
  return <nav aria-label="Application"><ul className="pz-nav">{items.map(item =>
    <li key={item.href}><a href={item.href} aria-current={current.startsWith(item.href) ? "page" : undefined}
      className={item.locked ? "is-locked" : undefined}>
      <span>{item.label}</span>{item.locked && <span className="pz-plan-badge" aria-label={`Available on the ${item.plan} plan`}>⌁ {item.plan}</span>}
    </a></li>)}</ul></nav>;
}
